export enum RolesEnum {
  Admin = 1,
  Operations = 2,
  DRO = 3,
  Client = 4,
}
